import React, { useState, useEffect, useCallback } from "react";
import downArrowGif from './Gif/downArrow.gif';

export const DownArrow = () => {
  const [downClass, setDownClass] = useState(null);
  const CalculatingHeight = useCallback(() => {
    let windowScrollHeight = window.scrollY;
    // console.log(windowScrollHeight);
    if (window !== undefined) {
      return windowScrollHeight > 3
        ? setDownClass("hide-down-arrow")
        : setDownClass(null);
    }
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", CalculatingHeight);
    return () => window.removeEventListener("scroll", CalculatingHeight);
  }, [CalculatingHeight]);

  return (
    <div className={`down-arrow-btn-more ${downClass}`}>
      <p>See more</p>
      <img src={downArrowGif} alt="gif" className="downarrowGif"/>
    </div>
  );
};
